// @flow
import goBack from 'fg-frontend/webActions/goBack';
import toggleClass from 'fg-frontend/webActions/toggleClass';
import scrollToHref     from 'fg-frontend/webActions/scrollToHref';

export default (action) => {
	switch (action) {
		case 'goBack':
			return goBack;
		case 'toggleClass':
			return toggleClass;
		case 'scrollToHref':
			return scrollToHref;
		default:
			console.log(`Unknown action`);
			return null;
	}
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/configureWebActions.js